import React from "react";

const Icons = ({ status, size = 16, color = "black" }) => {

  switch (status) {
    case "All":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M19.25 14.6654V7.3321C19.2497 7.01061 19.1648 6.69485 19.0039 6.4165C18.843 6.13816 18.6118 5.90702 18.3333 5.74627L11.9167 2.0796C11.638 1.9187 11.3218 1.83398 11 1.83398C10.6782 1.83398 10.362 1.9187 10.0833 2.0796L3.66667 5.74627C3.38824 5.90702 3.15698 6.13816 2.99609 6.4165C2.8352 6.69485 2.75033 7.01061 2.75 7.3321V14.6654C2.75033 14.9869 2.8352 15.3027 2.99609 15.581C3.15698 15.8594 3.38824 16.0905 3.66667 16.2513L10.0833 19.9179C10.362 20.0788 10.6782 20.1636 11 20.1636C11.3218 20.1636 11.638 20.0788 11.9167 19.9179L18.3333 16.2513C18.6118 16.0905 18.843 15.8594 19.0039 15.581C19.1648 15.3027 19.2497 14.9869 19.25 14.6654Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.99707 6.38086L10.9996 11.01L19.0021 6.38086"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 20.24V11"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "In Progress":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16415_93745)">
            <path
              d="M0.75 9C0.75 9.41421 1.08579 9.75 1.5 9.75C1.91421 9.75 2.25 9.41421 2.25 9H0.75ZM17.25 9C17.25 8.58579 16.9142 8.25 16.5 8.25C16.0858 8.25 15.75 8.58579 15.75 9H17.25ZM3.87004 13.3872C3.60066 13.0726 3.12721 13.0359 2.81255 13.3053C2.4979 13.5746 2.4612 14.0481 2.73058 14.3628L3.87004 13.3872ZM14.13 4.61276C14.3993 4.92741 14.8728 4.96411 15.1874 4.69473C15.5021 4.42535 15.5388 3.9519 15.2694 3.63724L14.13 4.61276ZM16.242 0.746654C16.2402 0.332444 15.9029 -0.00184059 15.4887 7.45058e-06C15.0745 0.00185555 14.7402 0.339137 14.742 0.753346L16.242 0.746654ZM15.4987 2.23928L16.2486 2.23594V2.23594L15.4987 2.23928ZM12.7387 4.99928L12.7353 5.74928L12.7387 4.99928ZM11.2527 4.24265C10.8385 4.2408 10.5012 4.57508 10.4994 4.98929C10.4975 5.4035 10.8318 5.74078 11.246 5.74263L11.2527 4.24265ZM15.1922 4.427L15.7854 4.88602L15.7854 4.88602L15.1922 4.427ZM14.9264 4.69287L15.3854 5.286L15.3854 5.286L14.9264 4.69287ZM1.69639 17.193C1.69824 17.6072 2.03552 17.9415 2.44973 17.9397C2.86394 17.9378 3.19822 17.6006 3.19638 17.1863L1.69639 17.193ZM2.43974 15.7004L1.68975 15.7038L2.43974 15.7004ZM5.19974 12.9404L5.20308 12.1904H5.20308L5.19974 12.9404ZM6.68568 13.697C7.09989 13.6989 7.43717 13.3646 7.43902 12.9504C7.44086 12.5362 7.10658 12.1989 6.69237 12.1971L6.68568 13.697ZM2.74615 13.5127L2.15302 13.0537L2.15302 13.0537L2.74615 13.5127ZM3.01202 13.2468L2.553 12.6537L2.553 12.6537L3.01202 13.2468ZM9 0.75C4.44365 0.75 0.75 4.44365 0.75 9H2.25C2.25 5.27208 5.27208 2.25 9 2.25V0.75ZM9 17.25C13.5563 17.25 17.25 13.5563 17.25 9H15.75C15.75 12.7279 12.7279 15.75 9 15.75V17.25ZM2.73058 14.3628C4.24255 16.1288 6.49074 17.25 9 17.25V15.75C6.9473 15.75 5.10919 14.8347 3.87004 13.3872L2.73058 14.3628ZM15.2694 3.63724C13.7575 1.87116 11.5093 0.75 9 0.75V2.25C11.0527 2.25 12.8908 3.16535 14.13 4.61276L15.2694 3.63724ZM14.742 0.753346L14.7487 2.24263L16.2486 2.23594L16.242 0.746654L14.742 0.753346ZM12.742 4.24929L11.2527 4.24265L11.246 5.74263L12.7353 5.74928L12.742 4.24929ZM14.7487 2.24263C14.7514 2.8541 14.752 3.24933 14.7198 3.54478C14.6891 3.82513 14.6369 3.91916 14.5991 3.96798L15.7854 4.88602C16.0619 4.52864 16.1656 4.12265 16.2109 3.70762C16.2546 3.30767 16.2512 2.81214 16.2486 2.23594L14.7487 2.24263ZM12.7353 5.74928C13.3115 5.75185 13.807 5.7552 14.207 5.71152C14.622 5.66619 15.028 5.56258 15.3854 5.286L14.4673 4.09975C14.4185 4.13753 14.3245 4.18977 14.0441 4.22038C13.7487 4.25265 13.3535 4.25202 12.742 4.24929L12.7353 5.74928ZM14.5991 3.96798C14.5609 4.01731 14.5167 4.06157 14.4673 4.09975L15.3854 5.286C15.5351 5.17013 15.6695 5.03574 15.7854 4.88602L14.5991 3.96798ZM3.19638 17.1863L3.18973 15.6971L1.68975 15.7038L1.69639 17.193L3.19638 17.1863ZM5.19639 13.6904L6.68568 13.697L6.69237 12.1971L5.20308 12.1904L5.19639 13.6904ZM3.18973 15.6971C3.187 15.0856 3.18638 14.6904 3.21864 14.3949C3.24926 14.1146 3.30149 14.0205 3.33928 13.9717L2.15302 13.0537C1.87645 13.411 1.77283 13.817 1.7275 14.2321C1.68383 14.632 1.68718 15.1276 1.68975 15.7038L3.18973 15.6971ZM5.20308 12.1904C4.62688 12.1878 4.13136 12.1845 3.73141 12.2282C3.31638 12.2735 2.91038 12.3771 2.553 12.6537L3.47104 13.8399C3.51986 13.8022 3.61389 13.7499 3.89425 13.7193C4.18969 13.687 4.58492 13.6877 5.19639 13.6904L5.20308 12.1904ZM3.33928 13.9717C3.37745 13.9224 3.42171 13.8781 3.47104 13.8399L2.553 12.6537C2.40328 12.7696 2.26889 12.9039 2.15302 13.0537L3.33928 13.9717Z"
              fill=""
            />
          </g>
          <defs>
            <clipPath id="clip0_16415_93745">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "Action Required":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          color={color} // Use the color prop
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0034 5.83268V10.8327M10.0034 17.4993C6.21412 17.4993 4.31947 17.4993 3.22419 16.7036C2.26885 16.0095 1.65289 14.9426 1.52946 13.7682C1.38794 12.4218 2.33527 10.781 4.22992 7.49935C6.12458 4.21771 7.0719 2.5769 8.30869 2.02624C9.38747 1.54594 10.6194 1.54594 11.6982 2.02624C12.9349 2.5769 13.8823 4.21771 15.7769 7.49935C17.6716 10.781 18.6189 12.4218 18.4774 13.7682C18.354 14.9426 17.738 16.0095 16.7827 16.7036C15.6874 17.4993 13.7927 17.4993 10.0034 17.4993Z"
            stroke="currentColor" // Use currentColor for dynamic color
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M10.8385 13.3333C10.8385 13.7936 10.4654 14.1667 10.0052 14.1667C9.54497 14.1667 9.17188 13.7936 9.17188 13.3333C9.17188 12.8731 9.54497 12.5 10.0052 12.5C10.4654 12.5 10.8385 12.8731 10.8385 13.3333Z"
            fill="currentColor" // Use currentColor for dynamic color
          />
        </svg>
      );
    case "Requested Follow Up":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.21756 17.5369L4.57023 17.0515L4.21756 17.5369ZM3.29576 16.6151L3.78117 16.2625L3.29576 16.6151ZM16.7042 16.6151L16.2188 16.2625L16.7042 16.6151ZM15.7824 17.5369L16.1351 18.0223L15.7824 17.5369ZM15.7824 4.12844L16.1351 3.64303L15.7824 4.12844ZM16.7042 5.05024L16.2188 5.40292L16.7042 5.05024ZM4.21756 4.12844L4.57023 4.61386L4.21756 4.12844ZM3.29576 5.05024L3.78117 5.40292L3.29576 5.05024ZM16.0149 13.384L15.921 12.7914L16.0149 13.384ZM12.5513 16.8475L11.9587 16.7537L12.5513 16.8475ZM11.9 4.16602C11.9 4.49739 12.1686 4.76602 12.5 4.76602C12.8314 4.76602 13.1 4.49739 13.1 4.16602H11.9ZM13.1 1.66602C13.1 1.33464 12.8314 1.06602 12.5 1.06602C12.1686 1.06602 11.9 1.33464 11.9 1.66602H13.1ZM6.9 4.16602C6.9 4.49739 7.16863 4.76602 7.5 4.76602C7.83137 4.76602 8.1 4.49739 8.1 4.16602H6.9ZM8.1 1.66602C8.1 1.33464 7.83137 1.06602 7.5 1.06602C7.16863 1.06602 6.9 1.33464 6.9 1.66602H8.1ZM17.4759 13.3327L18.0755 13.3532L17.4759 13.3327ZM12.5 18.3086L12.5205 18.9082L12.5 18.3086ZM10 17.7327C8.42425 17.7327 7.29063 17.7319 6.41234 17.6367C5.54529 17.5428 4.99854 17.3627 4.57023 17.0515L3.86489 18.0223C4.53185 18.5069 5.31394 18.7247 6.28309 18.8297C7.24101 18.9335 8.45098 18.9327 10 18.9327V17.7327ZM1.9 10.8327C1.9 12.3817 1.89918 13.5917 2.00296 14.5496C2.10796 15.5187 2.32577 16.3008 2.81035 16.9678L3.78117 16.2625C3.46999 15.8341 3.28992 15.2874 3.19598 14.4203C3.10082 13.5421 3.1 12.4084 3.1 10.8327H1.9ZM4.57023 17.0515C4.26744 16.8315 4.00116 16.5652 3.78117 16.2625L2.81035 16.9678C3.10436 17.3725 3.46023 17.7283 3.86489 18.0223L4.57023 17.0515ZM16.2188 16.2625C15.9988 16.5652 15.7326 16.8315 15.4298 17.0515L16.1351 18.0223C16.5398 17.7283 16.8956 17.3725 17.1896 16.9678L16.2188 16.2625ZM18.1 10.8327C18.1 9.28366 18.1008 8.0737 17.997 7.11577C17.892 6.14662 17.6742 5.36454 17.1896 4.69757L16.2188 5.40292C16.53 5.83122 16.7101 6.37797 16.804 7.24503C16.8992 8.12331 16.9 9.25693 16.9 10.8327H18.1ZM15.4298 4.61386C15.7326 4.83385 15.9988 5.10012 16.2188 5.40292L17.1896 4.69757C16.8956 4.29291 16.5398 3.93704 16.1351 3.64303L15.4298 4.61386ZM3.1 10.8327C3.1 9.25693 3.10082 8.12331 3.19598 7.24503C3.28992 6.37797 3.46999 5.83122 3.78117 5.40292L2.81035 4.69757C2.32577 5.36454 2.10796 6.14662 2.00296 7.11577C1.89918 8.0737 1.9 9.28366 1.9 10.8327H3.1ZM3.86489 3.64303C3.46023 3.93704 3.10436 4.29291 2.81035 4.69757L3.78117 5.40292C4.00116 5.10012 4.26744 4.83385 4.57023 4.61386L3.86489 3.64303ZM15.921 12.7914C13.8814 13.1144 12.2817 14.7141 11.9587 16.7537L13.1439 16.9414C13.3856 15.4152 14.5826 14.2183 16.1087 13.9766L15.921 12.7914ZM8.1 4.16602V3.35679H6.9V4.16602H8.1ZM8.1 3.35679V1.66602H6.9V3.35679H8.1ZM10 2.73268C9.02922 2.73268 8.19554 2.73261 7.47945 2.75714L7.52054 3.95644C8.2117 3.93276 9.02257 3.93268 10 3.93268V2.73268ZM7.47945 2.75714C5.91856 2.81062 4.77797 2.97964 3.86489 3.64303L4.57023 4.61386C5.16483 4.18186 5.97446 4.00941 7.52054 3.95644L7.47945 2.75714ZM13.1 4.16602V3.35679H11.9V4.16602H13.1ZM13.1 3.35679V1.66602H11.9V3.35679H13.1ZM10 3.93268C10.9774 3.93268 11.7883 3.93276 12.4795 3.95644L12.5205 2.75714C11.8045 2.73261 10.9708 2.73268 10 2.73268V3.93268ZM12.4795 3.95644C14.0255 4.00941 14.8352 4.18186 15.4298 4.61386L16.1351 3.64303C15.222 2.97964 14.0814 2.81062 12.5205 2.75714L12.4795 3.95644ZM17.4759 12.7327C16.7397 12.7327 16.2997 12.7314 15.921 12.7914L16.1087 13.9766C16.371 13.935 16.6958 13.9327 17.4759 13.9327L17.4759 12.7327ZM16.9 10.8327C16.9 11.8101 16.8999 12.621 16.8762 13.3121L18.0755 13.3532C18.1001 12.6371 18.1 11.8035 18.1 10.8327H16.9ZM16.8762 13.3121C16.8233 14.8582 16.6508 15.6679 16.2188 16.2625L17.1896 16.9678C17.853 16.0547 18.0221 14.9141 18.0755 13.3532L16.8762 13.3121ZM13.1 18.3086C13.1 17.5285 13.1024 17.2037 13.1439 16.9414L11.9587 16.7537C11.8987 17.1324 11.9 17.5724 11.9 18.3086L13.1 18.3086ZM10 18.9327C10.9708 18.9327 11.8045 18.9328 12.5205 18.9082L12.4795 17.7089C11.7883 17.7326 10.9774 17.7327 10 17.7327V18.9327ZM12.5205 18.9082C14.0814 18.8547 15.222 18.6857 16.1351 18.0223L15.4298 17.0515C14.8352 17.4835 14.0255 17.656 12.4795 17.7089L12.5205 18.9082Z"
            fill={color}
          />
          <path
            d="M6.66667 7.49935C6.66667 7.95959 6.29357 8.33268 5.83333 8.33268C5.3731 8.33268 5 7.95959 5 7.49935C5 7.03911 5.3731 6.66602 5.83333 6.66602C6.29357 6.66602 6.66667 7.03911 6.66667 7.49935Z"
            fill={color}
          />
          <path
            d="M6.66667 10.8327C6.66667 11.2929 6.29357 11.666 5.83333 11.666C5.3731 11.666 5 11.2929 5 10.8327C5 10.3724 5.3731 9.99935 5.83333 9.99935C6.29357 9.99935 6.66667 10.3724 6.66667 10.8327Z"
            fill={color}
          />
          <path
            d="M10.8333 7.49935C10.8333 7.95959 10.4602 8.33268 10 8.33268C9.53976 8.33268 9.16667 7.95959 9.16667 7.49935C9.16667 7.03911 9.53976 6.66602 10 6.66602C10.4602 6.66602 10.8333 7.03911 10.8333 7.49935Z"
            fill={color}
          />
          <path
            d="M10.8333 10.8327C10.8333 11.2929 10.4602 11.666 10 11.666C9.53976 11.666 9.16667 11.2929 9.16667 10.8327C9.16667 10.3724 9.53976 9.99935 10 9.99935C10.4602 9.99935 10.8333 10.3724 10.8333 10.8327Z"
            fill={color}
          />
          <path
            d="M10.8333 14.166C10.8333 14.6263 10.4602 14.9993 10 14.9993C9.53976 14.9993 9.16667 14.6263 9.16667 14.166C9.16667 13.7058 9.53976 13.3327 10 13.3327C10.4602 13.3327 10.8333 13.7058 10.8333 14.166Z"
            fill={color}
          />
          <path
            d="M15 7.49935C15 7.95959 14.6269 8.33268 14.1667 8.33268C13.7064 8.33268 13.3333 7.95959 13.3333 7.49935C13.3333 7.03911 13.7064 6.66602 14.1667 6.66602C14.6269 6.66602 15 7.03911 15 7.49935Z"
            fill={color}
          />
          <path
            d="M15 10.8327C15 11.2929 14.6269 11.666 14.1667 11.666C13.7064 11.666 13.3333 11.2929 13.3333 10.8327C13.3333 10.3724 13.7064 9.99935 14.1667 9.99935C14.6269 9.99935 15 10.3724 15 10.8327Z"
            fill={color}
          />
          <path
            d="M6.66667 14.166C6.66667 14.6263 6.29357 14.9993 5.83333 14.9993C5.3731 14.9993 5 14.6263 5 14.166C5 13.7058 5.3731 13.3327 5.83333 13.3327C6.29357 13.3327 6.66667 13.7058 6.66667 14.166Z"
            fill={color}
          />
        </svg>
      );
    case "Qualified":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 8.33203C2.5 7.18144 3.43274 6.2487 4.58333 6.2487C5.73393 6.2487 6.66667 7.18144 6.66667 8.33203V14.9987C6.66667 16.1493 5.73393 17.082 4.58333 17.082C3.43274 17.082 2.5 16.1493 2.5 14.9987V8.33203Z"
            stroke={color}
            strokeWidth="1.5"
          />
          <path
            d="M9.64618 3.90699L7.7874 6.92751C7.28834 7.73848 7.03881 8.14396 6.88792 8.58832C6.8419 8.72386 6.80289 8.86169 6.77105 9.00124C6.66667 9.45876 6.66667 9.93488 6.66667 10.8871V13.7487C6.66667 15.5896 8.15905 17.082 10 17.082H12.4249C14.0031 17.082 15.4458 16.1904 16.1516 14.7788L17.1087 12.8646C18.0542 10.9736 16.6792 8.7487 14.565 8.7487H13.9902C12.5494 8.7487 11.4476 7.46442 11.6667 6.04037L11.8692 4.72388C11.9818 3.99204 11.4156 3.33203 10.6751 3.33203C10.2556 3.33203 9.86606 3.54968 9.64618 3.90699Z"
            stroke={color}
            strokeWidth="1.5"
          />
        </svg>
      );
    case "Booked":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16415_93783)">
            <path
              d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.5 3L9 10.5075L6.75 8.2575"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_16415_93783">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "DNQ Criteria Not Met":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16415_93792)">
            <path
              d="M3.78847 14.3935L14.3935 3.78847M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_16415_93792">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "DNQ Other":
      return <span className="trial-empty-status"></span>;
    case "DNQ No Response":
      return <span className="trial-empty-status"></span>;
    case "DNQ Not Interested":
      return <span className="trial-empty-status"></span>;

    case "Non-textable":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.75191 14.2129L9.18784 14.8232H9.18784L8.75191 14.2129ZM8.79168 14.1846L8.35967 13.5715L8.79168 14.1846ZM10.9277 13.5001L10.9325 14.2501L10.9277 13.5001ZM5.54693 14.6327L4.85057 14.3541V14.3541L5.54693 14.6327ZM6.79386 15.6115L6.35793 15.0012H6.35793L6.79386 15.6115ZM16.3485 10.8051L15.6288 10.5941L16.3485 10.8051ZM13.8051 13.3485L13.5941 12.6288L13.8051 13.3485ZM3.54754 1.90873L3.20704 1.24047L3.54754 1.90873ZM1.90873 3.54754L1.24047 3.20704L1.90873 3.54754ZM14.4525 1.90873L14.793 1.24047L14.4525 1.90873ZM16.0913 3.54754L16.7595 3.20704L16.0913 3.54754ZM10.5 0.75H7.5V2.25H10.5V0.75ZM0.75 7.5V10.6713H2.25V7.5H0.75ZM17.25 8.38816V7.5H15.75V8.38816H17.25ZM4.32874 14.25H4.78006V12.75H4.32874V14.25ZM7.22979 16.2218L9.18784 14.8232L8.31598 13.6026L6.35793 15.0012L7.22979 16.2218ZM10.9766 14.25H11.3882V12.75H10.9766V14.25ZM9.18784 14.8232C9.20859 14.8084 9.2163 14.8029 9.2237 14.7977L8.35967 13.5715C8.34744 13.5801 8.33518 13.5889 8.31598 13.6026L9.18784 14.8232ZM10.9766 12.75C10.9529 12.75 10.9379 12.75 10.9229 12.7501L10.9325 14.2501C10.9416 14.25 10.9511 14.25 10.9766 14.25V12.75ZM9.2237 14.7977C9.7241 14.4451 10.3204 14.254 10.9325 14.2501L10.9229 12.7501C10.0047 12.756 9.11027 13.0426 8.35967 13.5715L9.2237 14.7977ZM4.78006 14.25C4.83378 14.25 4.87052 14.3043 4.85057 14.3541L6.24328 14.9112C6.65735 13.8761 5.89498 12.75 4.78006 12.75V14.25ZM4.85057 14.3541C4.26603 15.8155 5.94903 17.1367 7.22979 16.2218L6.35793 15.0012C6.34116 15.0132 6.33041 15.017 6.32606 15.0182C6.32145 15.0196 6.31777 15.0199 6.31387 15.0197C6.30481 15.0192 6.28672 15.0147 6.2669 14.9992C6.24708 14.9836 6.23845 14.9671 6.23582 14.9584C6.23468 14.9547 6.23413 14.951 6.23434 14.9462C6.23453 14.9417 6.23563 14.9304 6.24328 14.9112L4.85057 14.3541ZM15.75 8.38816C15.75 9.70779 15.7424 10.2068 15.6288 10.5941L17.0682 11.0162C17.2576 10.3701 17.25 9.60225 17.25 8.38816H15.75ZM11.3882 14.25C12.6022 14.25 13.3701 14.2576 14.0162 14.0682L13.5941 12.6288C13.2068 12.7424 12.7078 12.75 11.3882 12.75V14.25ZM15.6288 10.5941C15.3413 11.5746 14.5746 12.3413 13.5941 12.6288L14.0162 14.0682C15.4869 13.637 16.637 12.4869 17.0682 11.0162L15.6288 10.5941ZM0.75 10.6713C0.75 12.6477 2.35226 14.25 4.32874 14.25V12.75C3.18068 12.75 2.25 11.8193 2.25 10.6713H0.75ZM7.5 0.75C6.46228 0.75 5.63888 0.749417 4.97593 0.803582C4.30423 0.858462 3.73148 0.973257 3.20704 1.24047L3.88803 2.57698C4.16576 2.43547 4.51914 2.3459 5.09808 2.2986C5.68578 2.25058 6.43753 2.25 7.5 2.25V0.75ZM2.25 7.5C2.25 6.43753 2.25058 5.68578 2.2986 5.09808C2.3459 4.51914 2.43547 4.16576 2.57698 3.88803L1.24047 3.20704C0.973257 3.73148 0.858462 4.30423 0.803582 4.97593C0.749417 5.63888 0.75 6.46228 0.75 7.5H2.25ZM3.20704 1.24047C2.36031 1.6719 1.6719 2.36031 1.24047 3.20704L2.57698 3.88803C2.8646 3.32354 3.32354 2.8646 3.88803 2.57698L3.20704 1.24047ZM10.5 2.25C11.5625 2.25 12.3142 2.25058 12.9019 2.2986C13.4809 2.3459 13.8342 2.43547 14.112 2.57698L14.793 1.24047C14.2685 0.973257 13.6958 0.858462 13.0241 0.803582C12.3611 0.749417 11.5377 0.75 10.5 0.75V2.25ZM17.25 7.5C17.25 6.46228 17.2506 5.63888 17.1964 4.97593C17.1415 4.30423 17.0267 3.73148 16.7595 3.20704L15.423 3.88803C15.5645 4.16576 15.6541 4.51914 15.7014 5.09808C15.7494 5.68578 15.75 6.43753 15.75 7.5H17.25ZM14.112 2.57698C14.6765 2.8646 15.1354 3.32354 15.423 3.88803L16.7595 3.20704C16.3281 2.36031 15.6397 1.6719 14.793 1.24047L14.112 2.57698Z"
            fill={color}
          />
          <path
            d="M7 6L11.1005 10.1005"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 10.1016L11.1005 6.00106"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "To-call":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16415_93812)">
            <path
              d="M13.773 8.39429V7.97003C13.773 7.90654 13.773 7.8748 13.7726 7.84795C13.7435 5.81891 12.1057 4.18109 10.0767 4.15203C10.0498 4.15165 10.0181 4.15165 9.95458 4.15165H9.53032M16.4247 8.92462V8.18216C16.4247 7.54868 16.4247 7.23194 16.4008 6.96495C16.1419 4.07393 13.8508 1.78274 10.9597 1.5239C10.6928 1.5 10.376 1.5 9.74253 1.5L9.00007 1.5M6.58339 6.91754C6.24346 7.69738 6.4155 8.60581 7.01704 9.20735L8.81464 11.005C9.41618 11.6065 10.3246 11.7785 11.1044 11.4386C11.8843 11.0987 12.7927 11.2707 13.3943 11.8723L14.4879 12.9659C14.5409 13.0189 14.5674 13.0454 14.5888 13.0687C15.1161 13.6426 15.1161 14.5247 14.5888 15.0985C14.5674 15.1219 14.5409 15.1484 14.4879 15.2014L13.8231 15.8661C13.2818 16.4075 12.5014 16.6347 11.7541 16.4686C6.66186 15.337 2.68496 11.3601 1.55336 6.26794C1.38729 5.52059 1.61454 4.74019 2.15588 4.19885L2.82064 3.53409C2.87362 3.48111 2.90012 3.45461 2.92346 3.43317C3.49732 2.90586 4.37941 2.90586 4.95327 3.43317C4.97661 3.45461 5.0031 3.48111 5.05609 3.53409L6.14974 4.62774C6.75127 5.22928 6.92332 6.1377 6.58339 6.91754Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_16415_93812">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "Contact Attempt 1":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16415_93812)">
            <path
              d="M13.773 8.39429V7.97003C13.773 7.90654 13.773 7.8748 13.7726 7.84795C13.7435 5.81891 12.1057 4.18109 10.0767 4.15203C10.0498 4.15165 10.0181 4.15165 9.95458 4.15165H9.53032M16.4247 8.92462V8.18216C16.4247 7.54868 16.4247 7.23194 16.4008 6.96495C16.1419 4.07393 13.8508 1.78274 10.9597 1.5239C10.6928 1.5 10.376 1.5 9.74253 1.5L9.00007 1.5M6.58339 6.91754C6.24346 7.69738 6.4155 8.60581 7.01704 9.20735L8.81464 11.005C9.41618 11.6065 10.3246 11.7785 11.1044 11.4386C11.8843 11.0987 12.7927 11.2707 13.3943 11.8723L14.4879 12.9659C14.5409 13.0189 14.5674 13.0454 14.5888 13.0687C15.1161 13.6426 15.1161 14.5247 14.5888 15.0985C14.5674 15.1219 14.5409 15.1484 14.4879 15.2014L13.8231 15.8661C13.2818 16.4075 12.5014 16.6347 11.7541 16.4686C6.66186 15.337 2.68496 11.3601 1.55336 6.26794C1.38729 5.52059 1.61454 4.74019 2.15588 4.19885L2.82064 3.53409C2.87362 3.48111 2.90012 3.45461 2.92346 3.43317C3.49732 2.90586 4.37941 2.90586 4.95327 3.43317C4.97661 3.45461 5.0031 3.48111 5.05609 3.53409L6.14974 4.62774C6.75127 5.22928 6.92332 6.1377 6.58339 6.91754Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_16415_93812">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "Contact Attempt 2":
      return <span className="trial-empty-status"></span>;
    case "Contact Attempt 3":
      return <span className="trial-empty-status"></span>;

    case "Scheduled Screen":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 1.5V4.5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 1.5V4.5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 7.5H15.75"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "Queued":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M20.9193 11.0003C20.9193 10.5861 20.5835 10.2503 20.1693 10.2503C19.7551 10.2503 19.4193 10.5861 19.4193 11.0003H20.9193ZM16.5035 3.66699L16.053 4.26661V4.26661L16.5035 3.66699ZM18.3359 5.49943L17.7363 5.94994L17.7669 5.99069L17.8028 6.02693L18.3359 5.49943ZM19.6881 0.913646C19.6862 0.499437 19.3489 0.165152 18.9347 0.167C18.5205 0.168848 18.1862 0.506129 18.1881 0.920338L19.6881 0.913646ZM18.9462 2.73723L19.6962 2.73388V2.73388L18.9462 2.73723ZM15.5728 6.11056L15.5695 6.86056H15.5695L15.5728 6.11056ZM13.756 5.35245C13.3417 5.3506 13.0045 5.68489 13.0026 6.0991C13.0008 6.5133 13.3351 6.85059 13.7493 6.85243L13.756 5.35245ZM18.5717 5.41111L19.1648 5.87013V5.87013L18.5717 5.41111ZM18.2467 5.73606L18.7057 6.32919V6.32919L18.2467 5.73606ZM18.4195 5.5839L18.9498 6.11423L18.4195 5.5839ZM19.4193 11.0003C19.4193 15.6487 15.651 19.417 11.0026 19.417V20.917C16.4794 20.917 20.9193 16.4771 20.9193 11.0003H19.4193ZM11.0026 19.417C6.35421 19.417 2.58594 15.6487 2.58594 11.0003H1.08594C1.08594 16.4771 5.52578 20.917 11.0026 20.917V19.417ZM2.58594 11.0003C2.58594 6.35193 6.35421 2.58366 11.0026 2.58366V1.08366C5.52578 1.08366 1.08594 5.5235 1.08594 11.0003H2.58594ZM11.0026 2.58366C12.8986 2.58366 14.6462 3.20968 16.053 4.26661L16.954 3.06737C15.2964 1.82196 13.2346 1.08366 11.0026 1.08366V2.58366ZM16.053 4.26661C16.6903 4.74543 17.2575 5.31264 17.7363 5.94994L18.9356 5.04893C18.3719 4.29867 17.7043 3.63106 16.954 3.06737L16.053 4.26661ZM18.1881 0.920338L18.1962 2.74057L19.6962 2.73388L19.6881 0.913646L18.1881 0.920338ZM15.5762 5.36057L13.756 5.35245L13.7493 6.85243L15.5695 6.86056L15.5762 5.36057ZM18.1962 2.74057C18.1995 3.48401 18.2006 3.97821 18.1599 4.35092C18.1208 4.70854 18.0513 4.85813 17.9785 4.95209L19.1648 5.87013C19.4763 5.46761 19.5972 5.00606 19.651 4.51376C19.7031 4.03655 19.6993 3.44205 19.6962 2.73388L18.1962 2.74057ZM15.5695 6.86056C16.2777 6.86371 16.8722 6.8675 17.3494 6.81539C17.8417 6.76163 18.3032 6.64069 18.7057 6.32919L17.7877 5.14293C17.6937 5.21564 17.5442 5.2852 17.1865 5.32425C16.8138 5.36496 16.3196 5.36389 15.5762 5.36057L15.5695 6.86056ZM17.9786 4.95209C17.9509 4.98781 17.9211 5.0217 17.8892 5.05357L18.9498 6.11423C19.0265 6.03757 19.0983 5.95605 19.1648 5.87013L17.9786 4.95209ZM17.8892 5.05357C17.8573 5.08544 17.8234 5.11529 17.7877 5.14293L18.7057 6.32919C18.7917 6.2627 18.8732 6.19089 18.9498 6.11423L17.8892 5.05357ZM17.8028 6.02693L17.8864 6.1114L18.9527 5.0564L18.8691 4.97193L17.8028 6.02693Z"
            fill={color}
          />
          <path
            d="M15.538 12.9444L13.2627 12.9545C11.4482 12.9626 10.541 12.9667 9.9204 12.4864C9.76834 12.3687 9.63187 12.2323 9.5142 12.0802C9.03393 11.4596 9.03798 10.5524 9.04607 8.73787L9.05623 6.46257"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case "pdf":
      return (
        <svg
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16323_70238)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.89613 0H12.0031L17.1419 5.33748V17.7515C17.1419 18.9845 16.0848 19.9995 14.8005 19.9995H3.89613C2.61144 19.9995 1.55469 18.988 1.55469 17.7515V2.24787C1.55469 1.01141 2.60822 0 3.89613 0Z"
              fill="#FB8E2C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8875 5.21484H13.8867L17.1439 7.37913V5.34373H14.9305C14.5454 5.33787 14.1977 5.29393 13.8875 5.21484Z"
              fill="#C05D03"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0039 0L17.1427 5.33744V5.34416H14.9293C13.0942 5.31609 12.1062 4.42951 12.0039 2.9445V0Z"
              fill="#FF9F48"
            />
            <path
              d="M0 16.8536V9.18741L0.00113707 9.13325C0.0282642 8.42692 0.583193 7.85742 1.25743 7.85742H1.55136V10.0301H15.4794C16.0017 10.0301 16.4286 10.4815 16.4286 11.0339V16.8536C16.4286 17.4046 16.0004 17.8574 15.4794 17.8574H0.949166C0.428065 17.8574 0 17.4054 0 16.8536Z"
              fill="#C05D03"
            />
            <path
              d="M5.84207 7.08227C5.75031 7.08227 5.66231 7.04728 5.59743 6.98499C5.53254 6.92269 5.49609 6.83821 5.49609 6.75012C5.49609 6.66203 5.53254 6.57754 5.59743 6.51525C5.66231 6.45296 5.75031 6.41797 5.84207 6.41797H12.8582C12.9499 6.41797 13.0379 6.45296 13.1028 6.51525C13.1677 6.57754 13.2041 6.66203 13.2041 6.75012C13.2041 6.83821 13.1677 6.92269 13.1028 6.98499C13.0379 7.04728 12.9499 7.08227 12.8582 7.08227H5.84207Z"
              fill="white"
            />
            <path
              d="M0.714844 10.7148V16.6038C0.714844 16.9004 0.964698 17.1434 1.27012 17.1434H15.1596C15.465 17.1434 15.7148 16.9006 15.7148 16.6038V11.523C15.7148 11.2262 15.4647 10.9834 15.1596 10.9834H1.7551C1.26096 10.9797 0.988077 10.9211 0.714844 10.7148Z"
              fill="white"
            />
            <path
              d="M12.0227 13.3023V14.1717H13.5748V14.6207H12.0227V15.7146H11.4258V12.8574H13.7722V13.3023H12.0227Z"
              fill="#151D48"
            />
            <path
              d="M7.23828 12.8574H8.64338C8.98624 12.8574 9.29083 12.9173 9.55716 13.037C9.82349 13.154 10.0301 13.3214 10.1771 13.5391C10.324 13.754 10.3975 14.003 10.3975 14.286C10.3975 14.569 10.324 14.8193 10.1771 15.037C10.0301 15.252 9.82349 15.4193 9.55716 15.5391C9.29083 15.6561 8.98624 15.7146 8.64338 15.7146H7.23828V12.8574ZM8.61583 15.2656C8.85155 15.2656 9.05818 15.2261 9.23573 15.1472C9.41634 15.0656 9.5541 14.9513 9.649 14.8044C9.74695 14.6547 9.79593 14.4819 9.79593 14.286C9.79593 14.0901 9.74695 13.9186 9.649 13.7717C9.5541 13.622 9.41634 13.5078 9.23573 13.4289C9.05818 13.3472 8.85155 13.3064 8.61583 13.3064H7.83522V15.2656H8.61583Z"
              fill="#151D48"
            />
            <path
              d="M4.89276 12.8574C5.17133 12.8574 5.41317 12.8982 5.61827 12.9799C5.82643 13.0615 5.98562 13.1785 6.09582 13.3309C6.20603 13.4833 6.26113 13.6642 6.26113 13.8737C6.26113 14.0806 6.20603 14.2615 6.09582 14.4166C5.98562 14.569 5.82643 14.686 5.61827 14.7676C5.41317 14.8493 5.17133 14.8901 4.89276 14.8901H4.16725V15.7146H3.57031V12.8574H4.89276ZM4.86521 14.4411C5.12541 14.4411 5.32286 14.3921 5.45756 14.2942C5.59225 14.1962 5.6596 14.0561 5.6596 13.8737C5.6596 13.6914 5.59225 13.5513 5.45756 13.4533C5.32286 13.3554 5.12541 13.3064 4.86521 13.3064H4.16725V14.4411H4.86521Z"
              fill="#151D48"
            />
          </g>
          <defs>
            <clipPath id="clip0_16323_70238">
              <rect width="17.1429" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "excel":
      return (
        <svg
          width="18"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16323_70224)">
            <path
              d="M15.0705 11.442L5.58203 9.76758V22.1398C5.58203 22.7046 6.04 23.163 6.60531 23.163H22.9778C23.5427 23.163 24.0011 22.7051 24.0011 22.1398V17.5816L15.0705 11.442Z"
              fill="#185C37"
            />
            <path
              d="M15.0705 0.837891H6.60531C6.04047 0.837891 5.58203 1.29586 5.58203 1.86117V6.4193L15.0705 12.0007L20.0936 13.6751L24.0006 12.0007V6.4193L15.0705 0.837891Z"
              fill="#21A366"
            />
            <path
              d="M5.58203 6.41797H15.0705V11.9994H5.58203V6.41797Z"
              fill="#107C41"
            />
            <path
              opacity="0.1"
              d="M12.3728 5.30273H5.58203V19.256H12.3728C12.9372 19.2541 13.3942 18.7971 13.3961 18.2327V6.32555C13.3942 5.76117 12.9372 5.30461 12.3728 5.30273Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M11.815 5.85938H5.58203V19.8131H11.815C12.3794 19.8113 12.8364 19.3542 12.8383 18.7898V6.88266C12.8359 6.31828 12.3789 5.86125 11.815 5.85938Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M11.815 5.85938H5.58203V18.6966H11.815C12.3794 18.6947 12.8364 18.2377 12.8383 17.6733V6.88266C12.8359 6.31828 12.3789 5.86125 11.815 5.85938Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M11.2567 5.85938H5.58203V18.6966H11.2567C11.8211 18.6947 12.2781 18.2377 12.28 17.6733V6.88266C12.2777 6.31828 11.8211 5.86125 11.2567 5.85938Z"
              fill="black"
            />
            <path
              d="M1.02328 5.85938H11.2561C11.8209 5.85938 12.2794 6.31734 12.2794 6.88266V17.1155C12.2794 17.6803 11.8214 18.1388 11.2561 18.1388H1.02328C0.457969 18.1388 0 17.6808 0 17.1155V6.88266C0 6.31734 0.457969 5.85938 1.02328 5.85938Z"
              fill="url(#paint0_linear_16323_70224)"
            />
            <path
              d="M3.16797 15.3249L5.32 11.9902L3.34797 8.67383H4.93422L6.01047 10.7949C6.10984 10.9965 6.17781 11.146 6.21484 11.2449H6.22891C6.29969 11.0841 6.37422 10.928 6.45203 10.7766L7.60234 8.67523H9.05875L7.03656 11.972L9.10984 15.3254H7.56016L6.31703 12.9976C6.25844 12.8987 6.20875 12.7946 6.16844 12.6868H6.15016C6.11359 12.7923 6.06531 12.8935 6.00625 12.9882L4.72656 15.3259L3.16797 15.3249Z"
              fill="white"
            />
            <path
              d="M22.9772 0.837891H15.0703V6.4193H24.0005V1.86117C24.0005 1.29586 23.5425 0.837891 22.9772 0.837891Z"
              fill="#33C481"
            />
            <path d="M15.0703 12H24.0005V17.5814H15.0703V12Z" fill="#107C41" />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_16323_70224"
              x1="2.13312"
              y1="5.06012"
              x2="10.1459"
              y2="18.938"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#18884F" />
              <stop offset="0.5" stop-color="#117E43" />
              <stop offset="1" stop-color="#0B6631" />
            </linearGradient>
            <clipPath id="clip0_16323_70224">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "Skipped":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.3846 0.0683594C15.7245 0.0683594 16 0.343876 16 0.683744V14.3169C16 14.6567 15.7245 14.9323 15.3846 14.9323C15.0447 14.9323 14.7692 14.6567 14.7692 14.3169V0.683744C14.7692 0.343876 15.0447 0.0683594 15.3846 0.0683594ZM8.79102 2.316L8.84868 2.34987C10.1195 3.09639 11.1107 3.67872 11.8357 4.19989C12.5642 4.72361 13.1071 5.24177 13.3919 5.89258C13.8398 6.91621 13.8398 8.08442 13.3919 9.10805C13.1071 9.75886 12.5642 10.277 11.8357 10.8007C11.1107 11.3219 10.1195 11.9042 8.84873 12.6507L8.79098 12.6847C7.52041 13.4311 6.52912 14.0134 5.72291 14.3917C4.91384 14.7714 4.19781 14.9928 3.49488 14.9177C2.39091 14.7996 1.39132 14.2108 0.742653 13.3023C0.33113 12.726 0.162259 11.9904 0.0809963 11.0891C-8.10012e-06 10.1907 -4.52811e-06 9.02694 6.90896e-08 7.53299V7.46763C-3.79451e-06 5.97368 -6.87746e-06 4.80991 0.0809979 3.9115C0.162261 3.01023 0.331132 2.27462 0.742655 1.69829C1.39132 0.789852 2.39091 0.201021 3.49488 0.0829586C4.19781 0.00778492 4.91385 0.229254 5.72292 0.608912C6.52913 0.98723 7.52043 1.56958 8.79102 2.316ZM5.20008 1.72311C4.44839 1.37038 3.98554 1.26827 3.62576 1.30675C2.87585 1.38695 2.1913 1.78747 1.74429 2.4135C1.52772 2.71679 1.38255 3.18179 1.30679 4.02202C1.23137 4.85857 1.23077 5.96679 1.23077 7.50031C1.23077 9.03384 1.23137 10.142 1.30679 10.9786C1.38255 11.8188 1.52772 12.2838 1.74429 12.5871C2.1913 13.2132 2.87585 13.6137 3.62576 13.6939C3.98554 13.7324 4.44839 13.6302 5.20007 13.2775C5.9485 12.9263 6.89089 12.3734 8.19655 11.6064C9.50214 10.8394 10.444 10.2854 11.1173 9.8014C11.7925 9.316 12.1145 8.95713 12.2643 8.61467C12.5746 7.90556 12.5746 7.09507 12.2643 6.38596C12.1145 6.0435 11.7925 5.68463 11.1173 5.19923C10.444 4.71521 9.50214 4.16118 8.19655 3.39421C6.89089 2.62719 5.94851 2.07431 5.20008 1.72311Z"
            fill={color}
          />
        </svg>
      );
    default:
      return <span>Icon not found</span>;
  }
};

export default Icons;
